import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { Group, GroupDetail, GroupListParams, GroupSummaryData } from './groupsManagement.types';

export const getGroupList = (client: AxiosInstance) => async (params?: GroupListParams) => {
  return (
    await client.get<PaginatedApiResponse<Group[]>>(API_ROUTES.GET_GROUP_LIST, {
      params: { ...params },
    })
  ).data;
};

export const getGroupSummary = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<GroupSummaryData>>(API_ROUTES.GET_GROUP_SUMMARY)).data;
};

export const getGroupDetail = (client: AxiosInstance) => async (groupId: string) => {
  return (
    await client.get<ApiResponse<GroupDetail>>(API_ROUTES.GET_GROUP_DETAIL, {
      params: { groupId: groupId || '' },
    })
  ).data;
};

export const groupQueries = {
  all: () => ['groups'],

  list: (params?: GroupListParams) =>
    queryFactoryOptions<PaginatedApiResponse<Group[]>>({
      queryKey: [...groupQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getGroupList(client)(params),
    }),

  summary: () =>
    queryFactoryOptions<ApiResponse<GroupSummaryData>>({
      queryKey: [...groupQueries.all(), 'summary'],
      queryFn: (client: AxiosInstance) => getGroupSummary(client),
    }),

  detail: (groupId: string) =>
    queryFactoryOptions<ApiResponse<GroupDetail>>({
      queryKey: [...groupQueries.all(), 'detail', groupId],
      queryFn: (client: AxiosInstance) => () => getGroupDetail(client)(groupId),
    }),
};
